import './reviews.scss';

class ReviewsControls {
  constructor(lang, theme) {
    this.lang = lang;
    this.theme = theme;
  }

  buildReviewsSection(lang, theme) {
    let reviewsSection = document.createElement('section');
    let reviewsHeader = document.createElement('h2');
    let reviewsReviewsHeader = document.createElement('h3');
    let reviewsWrapper = document.createElement('ul');
    let reviewsCard = document.createElement('li');
    let reviewsCardName = document.createElement('h3');
    let reviewsWCardText = document.createElement('p');
    let reviewsImage = document.createElement('div');

    let mainSection = document.querySelector('.main-section');

    reviewsSection.classList.add('reviews-section');
    reviewsHeader.classList.add('reviews-section__header');
    reviewsReviewsHeader.classList.add('reviews-section__reviews-header');
    reviewsWrapper.classList.add('reviews-section__wrapper');
    reviewsCard.classList.add('review-card');
    reviewsCardName.classList.add('review-card__name');
    reviewsWCardText.classList.add('review-card__review');
    reviewsImage.classList.add('review-card__img');

    if (theme === 'dark') {
      reviewsSection.classList.add('reviews-section_theme-color_dark');
      reviewsHeader.classList.add('reviews-section__header_theme-color_dark');
      reviewsReviewsHeader.classList.add('reviews-section__reviews-header_theme-color_dark');
      reviewsCard.classList.add('review-card_theme-color_dark');
      reviewsCardName.classList.add('review-card__name_theme-color_dark');
      reviewsWCardText.classList.add('review-card__review_theme-color_dark');
    } else {
      reviewsSection.classList.add('reviews-section_theme-color_light');
      reviewsHeader.classList.add('reviews-section__header_theme-color_light');
      reviewsReviewsHeader.classList.add('reviews-section__reviews-header_theme-color_light');
      reviewsCard.classList.add('review-card_theme-color_light');
      reviewsCardName.classList.add('review-card__name_theme-color_light');
      reviewsWCardText.classList.add('review-card__review_theme-color_light');
    }

    if (lang === 'ru') {
      reviewsHeader.classList.add('reviews-section__header_lang_ru');
      reviewsReviewsHeader.classList.add('reviews-section__reviews-header_lang_ru');
      reviewsCard.classList.add('review-card_lang_ru');
      reviewsCardName.classList.add('review-card__name_lang_ru');
      reviewsWCardText.classList.add('review-card__review_lang_ru');
    } else {
      reviewsHeader.classList.add('reviews-section__header_lang_en');
      reviewsReviewsHeader.classList.add('reviews-section__reviews-header_lang_en');
      reviewsCard.classList.add('review-card_lang_en');
      reviewsCardName.classList.add('review-card__name_lang_en');
      reviewsWCardText.classList.add('review-card__review_lang_en');
    }

    reviewsCard.appendChild(reviewsCardName);
    reviewsCard.appendChild(reviewsWCardText);
    reviewsCard.appendChild(reviewsImage);

    for (let i = 0; i < 3; i++) { 
      const copyCard = reviewsCard.cloneNode(true); 
      reviewsWrapper.appendChild(copyCard);
    }

    reviewsSection.appendChild(reviewsHeader);
    reviewsSection.appendChild(reviewsReviewsHeader);
    reviewsSection.appendChild(reviewsWrapper);
    mainSection.appendChild(reviewsSection);
  }
}

export { ReviewsControls };
